import { useNavigate } from 'react-router-dom';
import BackButton from './BackButton';
import './VideoPage.css';
import LaunchBayVideo from './video/launch-rocket.mp4';
import ReactPlayer from 'react-player';
import { AudioPlayer } from 'react-audio-play';
import LaunchBayAudio from './music/ticket-to-the-moon.wav';
import React, { useState, useEffect } from 'react';

const VideoPage = () => {
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 700);
  }, []);

  return (
    <div className="container">
      {loading ? (
        <div className="loader-container">
            <div className="spinner"></div>
        </div>
      ) : (
    <div className="video-page">
      <ReactPlayer url={LaunchBayVideo} className="video" playing={true} playsinline={true} />
      <p className="video-text">Escape to the stars...</p>
      <AudioPlayer src={LaunchBayAudio} autoPlay />
      <BackButton onClick={() => navigate('/fork')} />
    </div>
    )}
    </div>
  );
};

export default VideoPage;